import { createSlice } from '@reduxjs/toolkit';
import { documentListModel } from '@repo/prospects-api';

const initialState: documentListModel = {
  encodedKey: '',
  storageKey: '',
  status: '',
  documentType: '',
  title: '',
  required: false,
  generatedAt: '',
};

export const documentDataSlice = createSlice({
  name: 'documentData',
  initialState,
  reducers: {
    setDocumentData: (state, action: { payload: documentListModel }) => ({
      ...state,
      ...action.payload,
    }),
    resetDocumentData: () => initialState,
  },
});

export const { setDocumentData, resetDocumentData } = documentDataSlice.actions;

export default documentDataSlice.reducer;
